import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var PADDL_GAMES_VARIANT_ID = 4;
var getAllUniquePaddlGamesEventIdsFromActivites = function getAllUniquePaddlGamesEventIdsFromActivites(timelineActivities) {
  return timelineActivities.length ? _toConsumableArray(new Set(timelineActivities.filter(function (_ref) {
    var variantId = _ref.variantId;
    return variantId === PADDL_GAMES_VARIANT_ID;
  }).map(function (_ref2) {
    var details = _ref2.details;
    return details.eventId;
  }))) : [];
};
export var getDataForPaddlGamesInTimeline = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(timelineActivities, getContentfulDataByEventId) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", Promise.all(getAllUniquePaddlGamesEventIdsFromActivites(timelineActivities).map(function (id) {
            return getContentfulDataByEventId(id);
          })));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getDataForPaddlGamesInTimeline(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var getContentfulFieldForEventId = function getContentfulFieldForEventId(contentfulData, eventId) {
  var _contentfulData$find, _contentfulData$find$;
  return (_contentfulData$find = contentfulData.find(function (_ref4) {
    var items = _ref4.items;
    return items[0].fields.eventId === eventId;
  })) === null || _contentfulData$find === void 0 ? void 0 : (_contentfulData$find$ = _contentfulData$find.items[0]) === null || _contentfulData$find$ === void 0 ? void 0 : _contentfulData$find$.fields;
};